import { render, staticRenderFns } from "./CarryRegion.vue?vue&type=template&id=b9fba700&scoped=true&"
import script from "./CarryRegion.vue?vue&type=script&lang=ts&"
export * from "./CarryRegion.vue?vue&type=script&lang=ts&"
import style0 from "./CarryRegion.vue?vue&type=style&index=0&id=b9fba700&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9fba700",
  null
  
)

export default component.exports